export default ['/pdf/report/:reportId/', '/pdf/creativeProfile'];
